









































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

import UiFormLabel from '../ui/UiFormLabel.vue';
import UiSelect2 from '../ui/UiSelect2.vue';
import { buildLabelTemplateOptions, LabelRuleOption, LabelTrackingRule } from './helpers/labelRules';

type LabelDef = { labelId?: string; name?: string; enabled?: boolean; isDeleted?: boolean };

/**
 * Self-contained create-time "Inventory Tracking" picker. The user designates a
 * single label template (e.g. `client`) whose every value gets its own
 * independent inventory. Emits `input` with the resulting labelTrackingRule
 * (or undefined for no tracking). Vue 2 counterpart of web-app-v3's
 * LabelTrackingSection — kept as its own component so the interactivity is
 * mountable and unit-testable in isolation.
 */
@Component({ components: { UiFormLabel, UiSelect2 } })
export default class InventoryViewTrackingDimension extends Vue {
  @Prop({ default: () => [] })
  public readonly labelDefinitions!: LabelDef[];

  // Initialized to '' (not undefined) so vue-class-component makes it reactive;
  // an empty string means "no tracking dimension".
  public selectedTemplate = '';

  // Only templates can be a tracking dimension; flat labels and individual slug
  // values are never offered.
  get templateOptions(): LabelRuleOption[] {
    return buildLabelTemplateOptions(this.labelDefinitions);
  }

  @Watch('selectedTemplate')
  emitRule() {
    const rule: LabelTrackingRule | undefined = this.selectedTemplate ? { template: this.selectedTemplate } : undefined;
    this.$emit('input', rule);
  }
}
